import { render, staticRenderFns } from "./app-error.vue?vue&type=template&id=cf46fd24"
import script from "./app-error.vue?vue&type=script&lang=js"
export * from "./app-error.vue?vue&type=script&lang=js"
import style0 from "./app-error.vue?vue&type=style&index=0&id=cf46fd24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports